export default "__VITE_ASSET__29dc8daf__"